import { combineDateAndTime } from './volunteeringActivitySubmitHelpers'
import { parseTimeToHoursMinutes } from './parseTimeToHoursMinutes'
import type { LogVolunteeringActivityFormFields } from './LogVolunteeringActivity.types'
import { dayjs } from '@percent/workplace-giving/utils/dayjs/dayjs'
import { VolunteeringTimeLogType } from '@percent/workplace-giving/api/opportunity/dto'
import { SimulatedTimeLog } from '@percent/workplace-giving/api/gamification/simulateAccountRewards/simulateAccountRewards.types'

type TimeLogEntry = LogVolunteeringActivityFormFields['timeLogs'][number]

const isValidTime = (time?: string): time is string => !!parseTimeToHoursMinutes(time)

const toTimes = ({ date, startTime, endTime }: TimeLogEntry) => {
  if (!date || !isValidTime(startTime) || !isValidTime(endTime)) {
    return null
  }

  const start = dayjs(combineDateAndTime(date, startTime))
  const end = dayjs(combineDateAndTime(date, endTime))

  return end.isAfter(start) ? { startTime: start.toISOString(), endTime: end.toISOString() } : null
}

export const toSimulatedTimeLog = (
  { platform, opportunityId, organisationId, activities, duringWorkingHours }: LogVolunteeringActivityFormFields,
  entry: TimeLogEntry
): SimulatedTimeLog | null => {
  const times = toTimes(entry)

  if (!times) {
    return null
  }

  if (platform === VolunteeringTimeLogType.OnPlatform) {
    return opportunityId ? { kind: 'opportunity', opportunityId, ...times, duringWorkingHours } : null
  }

  return organisationId ? { kind: 'off_platform', organisationId, ...times, activities, duringWorkingHours } : null
}

export const toSimulatedTimeLogs = (values: LogVolunteeringActivityFormFields): SimulatedTimeLog[] =>
  values.timeLogs.flatMap(entry => {
    const timeLog = toSimulatedTimeLog(values, entry)

    return timeLog ? [timeLog] : []
  })
